export default __webpack_public_path__ + "static/media/1.55cebc47.jpg";